import React, { useState } from 'react'
import { Grid, IconButton } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiMicrosoftExcel, mdiMagnify } from '@mdi/js'
import { useDispatch } from 'react-redux'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { endOfMonth, startOfMonth } from 'date-fns'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { makeRelatory } from '../CatalogacaoRelatoryActions'

const Filter = ({ form, setForm }) => {
  const filterStyles = filterStylesComponents()
  const dispatch = useDispatch()

  const handleDownload = e => {
    e.preventDefault()
    dispatch(makeRelatory(form))
  }

  const handleSubmit = () => {
    setForm({ ...form })
  }

  return (
    <BaseFilter>
      <Grid container spacing={2}>
        <Grid
          item
          xs={10}
          container
          spacing={2}
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={3}>
            <KeyboardDatePicker
              clearable
              value={form.date_start}
              label="Data Inicial"
              fullWidth
              views={['date']}
              clearLabel="Limpar"
              invalidDateMessage="Data inválida"
              autoOk
              onChange={date => setForm({ ...form, date_start: date })}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item xs={3}>
            <KeyboardDatePicker
              clearable
              value={form.date_end}
              label="Data Final"
              fullWidth
              views={['date']}
              clearLabel="Limpar"
              invalidDateMessage="Data inválida"
              autoOk
              onChange={dateEnd => setForm({ ...form, date_end: dateEnd })}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item xs={3}>
            <IconButton className={filterStyles.btnAdd} onClick={handleSubmit}>
              <Icon path={mdiMagnify} size={1} />
              Pesquisar
            </IconButton>
          </Grid>
        </Grid>

        <Grid
          item
          xs
          className={filterStyles.areaButtons}
          container
          justifyContent="flex-end"
        >
          <Grid item>
            <IconButton
              className={filterStyles.btnAdd}
              onClick={handleDownload}
            >
              <Icon path={mdiMicrosoftExcel} size={1} />
              Download
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}

export default Filter
